import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import '../styles/index.scss';

const TrustMessage = ({className, icon, title, info, textFormat, reverse}) => {
  let content;
  if (textFormat === 'inlineTitle') {
    content = (
      <div className="TrustMessage__text">
        {title ? <strong>{title} - </strong> : null}
        {info}
      </div>
    );
  } else {
    content = (
      <div className="TrustMessage__text">
        {title ? <div className="TrustMessage__header">{title}</div> : null}
        {info}
      </div>
    );
  }

  const componentClass = classNames('TrustMessage', className, {
    'TrustMessage--reverse': reverse,
  });

  return (
    <div className={componentClass}>
      <div className="TrustMessage__img_wrapper">{icon}</div>
      {content}
    </div>
  );
};

TrustMessage.propTypes = {
  /** Additional class names to apply to the component. */
  className: PropTypes.string,

  /** The format of the text content. It can be either 'inlineTitle' where the title and info are displayed inline, or 'default' where the title and info are displayed in a block format. */
  textFormat: PropTypes.oneOf(['inlineTitle', 'default']),

  /** Boolean to reverse the order of the icon and text content. */
  reverse: PropTypes.bool,

  /** The title element of the trust message. */
  title: PropTypes.object,

  /** The informational content element of the trust message. */
  info: PropTypes.object,

  /** The icon element to display alongside the text content. */
  icon: PropTypes.element,
};

export default TrustMessage;
